import * as FetchActions from '../actions/FetchAction';
import * as LoginActions from '../actions/LoginActions';
import type { ILoginState } from '../appstate';
import { CreateAsynchronousActionReducer } from './GeneralReducers';

const initialState: ILoginState = {
	signingIn: {
		inProcess: false,
		error: false,
	},
	isUnauthorized: false,
	unknownError: false,
};

const signInReducer = CreateAsynchronousActionReducer({
	startAction: LoginActions.SIGNING_IN,
});

const singleSignOnReducer = CreateAsynchronousActionReducer({
	startAction: LoginActions.SINGLE_SIGN_ON,
});

const isSignInAction = (type: string) =>
	type === LoginActions.SIGNING_IN ||
	type === LoginActions.SIGNING_IN_SUCCESS ||
	type === LoginActions.SIGNING_IN_ERROR ||
	type === LoginActions.SIGNING_IN_UNKNOWN_ERROR;

export function loginReducer(state = initialState, action): any {
	switch (action.type) {
		case LoginActions.SIGNING_IN_SUCCESS:
		case LoginActions.SINGLE_SIGN_ON_SUCCESS: {
			const signingIn = isSignInAction(action.type)
				? signInReducer(state.signingIn, action)
				: singleSignOnReducer(state.signingIn, action);

			return {
				...state,
				signingIn,
				isUnauthorized: false,
				unknownError: false,
			};
		}
		case LoginActions.SIGNING_IN:
		case LoginActions.SIGNING_IN_ERROR:
		case LoginActions.SINGLE_SIGN_ON:
		case LoginActions.SINGLE_SIGN_ON_ERROR: {
			const signingIn = isSignInAction(action.type)
				? signInReducer(state.signingIn, action)
				: singleSignOnReducer(state.signingIn, action);

			return {
				...state,
				signingIn,
				isUnauthorized: true,
				unknownError: false,
			};
		}
		case LoginActions.SIGNING_IN_UNKNOWN_ERROR:
		case LoginActions.SINGLE_SIGN_ON_UNKNOWN_ERROR:
			return {
				...state,
				unknownError: true,
			};
		case FetchActions.UNAUTHORIZED_REQUEST:
			return {
				...state,
				isUnauthorized: action.payload,
			};
	}
	return state;
}
